import React, { useState } from 'react';
import styled from 'styled-components';
import { calc4k } from '../utilities';

import { colors, gradient, padding } from '../GlobalStyle';

import defaultScreen from '../data/images/default-screen.jpg';

console.log('defaultScreen', defaultScreen);

export default function( { size } ) {

    return (
        <DefaultScreen size={ size } image={ defaultScreen }>
            <Title>
                Welcome to the<br/>Asian Art Museum
            </Title>
            <Subtitle>
                Visit asianart.org for<br/>information on future events
            </Subtitle>
        </DefaultScreen>
    );
}

const DefaultScreen = styled.div`
    height: ${p => {
    switch( p.size ) {
        case 'tall':
            return calc4k(2724);
        case 'elevator':
            return calc4k(1580);
        case 'full':
            return '100vh';
        default:
            return calc4k(1916);
    }
}};
    position: relative;
    z-index: 0;
    background-image: url(${ p => p.image });
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-position: bottom;
    padding: 0 ${padding.sideTriple};
`;

const Title = styled.h2`
    font-size: ${ calc4k( 125 ) };
    margin-bottom: ${ calc4k( 50 ) };
    font-weight: 500;
    color: black;
    line-height: 1.1;
`;


const Subtitle = styled.div`
    font-size: ${ calc4k( 60 ) };
    line-height: 1.1;
    color: black;
    opacity: 0.75;
`;

